export function ensureType<T>(value: T): T {
	return value;
}
